//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import ElLottie from '@/components/UI/el-lottie'
import { mapState } from 'vuex'

export default {
  name: 'AtmSection',
  components: {
    ElLottie,
  },
  mixins: [scroll],
  props: {
    isGraphicDesign: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      eyeAnimation: {
        container: '.atm__eye',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/atm-eye.json`,
      },
      pictureAnimation: {
        container: '.atm__picture',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/atm-picture.json`,
      },
    }
  },
  computed: {
    ...mapState(['i18n']),
    isSnakeAllowed() {
      return this.i18n.locale === 'ru'
    },
  },
}
